import PropTypes from 'prop-types';

import ColumnShape from './ColumnShape';

export default PropTypes.shape({
  key: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(ColumnShape),
});
